var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-slider-component',{staticClass:"view-slider",class:_vm.classes,style:({
		paddingLeft: 0,
		paddingRight: 0
	}),attrs:{"min":_vm.min,"max":_vm.max,"interval":_vm.interval,"disabled":_vm.disabled ? true : false,"lazy":true,"tooltip":"hover","sliderStyle":{},"tooltipStyle":{},"processStyle":{}},model:{value:(_vm.ownValue),callback:function ($$v) {_vm.ownValue=$$v},expression:"ownValue"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64266c04","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/controls/Slider.vue
// module id = 278
// module chunks = 0